import { render, staticRenderFns } from "./delete-survey.vue?vue&type=template&id=567a25eb&scoped=true&"
import script from "./delete-survey.vue?vue&type=script&lang=js&"
export * from "./delete-survey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a25eb",
  null
  
)

export default component.exports